module.exports = __webpack_public_path__ + "static/img/chuntianbaihe_icon.4916d76.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shop_img_icon/chuntianbaihe_icon.png
// module id = OZyZ
// module chunks = 1